<template>
  <div class="app-sidebar" :class="{ open: sidebar }">
    <file-viewer :data="preview" v-model="dialogPreview" @onHide="hidePreview" />
    <div class="app-sidebar-header">
      <div class="d-flex d-inline">
        <img :src="require('@/assets/images/main-logo-dt.png')" class="app-sidebar-logo" />
        <div class="lite-card d-flex justify-center mt-2 ml-4" v-if="user.cerdasTypeId === 1"><strong class="lite-text">Lite</strong></div>
      </div>
      <div class="app-sidebar-user" v-if="$route.name !== 'StudentAssignmentScoreQuiz'" @click="detailProfile">
        <img v-if="$get(profile, 'imageUrl')" :src="$get(profile, 'imageUrl')" class="user-photo" />
        <img v-else :src="require('@/assets/images/sample-user.png')" class="user-photo" />
        <div class="user-info">
          <div class="user-info-primary">{{ $get(profile, 'fullName') }}</div>
          <div class="user-info-secondary">{{ currentRole }}</div>
        </div>
      </div>
      <div class="app-sidebar-user" v-else>
        <img v-if="$get(profile, 'imageUrl')" :src="$get(profile, 'imageUrl')" class="user-photo" />
        <img v-else :src="require('@/assets/images/sample-user.png')" class="user-photo" />
        <div class="user-info">
          <div class="user-info-primary">{{ $get(profile, 'fullName') }}</div>
          <div class="user-info-secondary">{{ currentRole }}</div>
        </div>
      </div>
    </div>
    <!-- MENU -->
    <ul class="app-menu" v-if="(role === 3 && !!student) || role != 3">
      <li v-for="({ url, icon, i18n: label, children }, index) in menus" :key="index">
        <slide-box v-if="children" class="app-menu-group">
          <template #activator="{isOpen}">
            <div class="app-menu-icon" v-if="icon">
              <svg-icon :icon="icon" />
            </div>
            <span class="app-menu-text">{{ $t(label) }}</span>
            <v-icon class="app-menu-indicator">{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
          </template>
          <template>
            <ul class="app-menu-group-items">
              <li v-for="(child, i2) in children" :key="index + i2">
                <router-link :to="{ name: child.url }">
                  {{ $t(child.i18n) }}
                </router-link>
              </li>
            </ul>
          </template>
        </slide-box>
        <template v-else>
          <router-link v-if="$route.name !== 'StudentAssignmentScoreQuiz'" :to="{ name: url }">
            <div class="app-menu-icon" v-if="icon">
              <svg-icon :icon="icon" />
            </div>
            <span class="app-menu-text">{{ $t(label) }}</span>
          </router-link>
        </template>
      </li>
    </ul>

    <!-- STUDENT LIST --->
    <div v-if="this.role === 3 && !!this.student && childs.length > 1" class="student-option">
      <v-select
        v-model="currentActiveStudent"
        :items="childs"
        item-value="studentId"
        item-text="fullName"
        :item-disabled="item => !item.classroomStudent"
        @change="changeStudent"
        :menu-props="{ top: true, offsetY: true }"
      >
        <template #selection="{item}">
          <div class="student-list">
            <img v-if="item.imageUrl" :src="item.imageUrl" class="student-list-photo" />
            <img v-else :src="require('@/assets/images/sample-user.png')" class="student-list-photo" />
            {{ item.fullName }}
          </div>
        </template>
        <template #item="{item}">
          <div class="student-list">
            <img v-if="item.imageUrl" :src="item.imageUrl" class="student-list-photo" />
            <img v-else :src="require('@/assets/images/sample-user.png')" class="student-list-photo" />
            {{ item.fullName }}
          </div>
        </template>
      </v-select>
    </div>

    <!-- Chat --->
    <v-menu
      v-if="(user.roleId === 5 && $route.name !== 'StudentAssignmentScoreQuiz') || user.roleId === 4 || (user.roleId === 3 && student)"
      top
      v-model="menu"
      :close-on-click="false"
      :close-on-content-click="false"
      transition="slide-x-transition"
      :nudge-top="40"
      offset-x
    >
      <template v-slot:activator="{ on }">
        <v-fab-transition>
          <v-btn
            v-model="fab"
            v-on="on"
            color="primary"
            elevation="4"
            fixed
            class="ml-2 mb-2"
            style="border-radius: 8px;"
            bottom
            left
            @click="
              fab = !fab;
              menu = false;
            "
          >
            {{ $t('content.chat') }}
            <v-badge overlap color="red" class="ml-2 mt-1 mb-1" :content="unread" :value="unread">
              <v-icon small class="ml-2 mt-1 mb-1">
                mdi-chat
              </v-icon>
            </v-badge>
          </v-btn>
        </v-fab-transition>
      </template>
      <v-card v-show="true" fab fixed large bottom right>
        <v-toolbar color="secondary" dark>
          <div v-if="statusContact === true && statusBroadcast === false" @click="statusContact = false" style="cursor: pointer;">
            <v-icon class="mr-2"> mdi-chevron-left</v-icon>
          </div>
          <div v-if="statusBroadcast === true && statusContact === false" @click="statusBroadcast = false" style="cursor: pointer;">
            <v-icon class="mr-2"> mdi-chevron-left</v-icon>
          </div>
          <v-toolbar-title v-if="statusBroadcast === false && statusContact === false">{{ $t('content.chat') }}</v-toolbar-title>
          <v-toolbar-title v-if="statusBroadcast === false && statusContact === true">{{ $t('content.contact') }}</v-toolbar-title>
          <v-toolbar-title v-if="statusBroadcast === true && statusContact === false">{{ $t('content.broadCast') }}</v-toolbar-title>
          <v-row justify="space-around" v-if="statusContact === false && statusBroadcast === false">
            <v-menu rounded="lg" offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-btn color="primary" class="white--text ma-5 ml-2" style="border-radius: 8px;" v-bind="attrs" v-on="on" small
                  ><v-icon class="mr-2" small> mdi-plus </v-icon>{{ $t('add') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item link @click="statusContact = true">
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('content.chat') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="statusBroadcast = true">
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('content.broadCast') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
          <v-spacer />
          <div
            @click="detailProfileChat"
            class="d-flex d-inline"
            style="cursor: pointer;"
            v-if="statusBroadcast === false && statusContact === false && chatView === false && statusSearch === false && JSON.stringify(to) !== '{}'"
          >
            <v-list-item-avatar class="mr-4">
              <v-img v-if="to.profileImg" :src="to.profileImg" />
              <v-img v-else :src="require('@/assets/images/sample-user.png')" />
            </v-list-item-avatar>
            <v-toolbar-title class="mt-3" style="margin-right: 60px;"> {{ to.name }}</v-toolbar-title>
          </div>
          <div class="d-flex d-inline" v-if="statusBroadcast === false && statusContact === false && chatView === true && statusSearch === false">
            <v-btn icon @click="chatView = false">
              <v-icon class="app-menu-indicator">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title class="mt-3" style="margin-right: 145px;">{{ $t('content.back_to_chat') }}</v-toolbar-title>
          </div>
          <v-spacer />
          <v-btn icon @click="goTopSearch" v-if="statusBroadcast === false && statusContact === false && statusSearch === true">
            <v-icon class="app-menu-indicator">mdi-chevron-up</v-icon>
          </v-btn>
          <v-btn icon @click="goDownSearch" v-if="statusBroadcast === false && statusContact === false && statusSearch === true">
            <v-icon class="app-menu-indicator">mdi-chevron-down</v-icon>
          </v-btn>
          <div v-if="statusBroadcast === false && statusContact === false && statusSearch === true">
            <v-text-field
              v-model="searchChat"
              :label="$t('search')"
              class="shrink  mr-2 mt-5"
              @input="searchChatInput"
              append-outer-icon="mdi-close"
              @keyup.enter="searchChatInput"
              @click:append-outer="
                statusSearch = false;
                searchChat = '';
                OnIndexSearch = 0;
                setListSearch = [];
              "
            >
              <template #prepend-inner>
                <v-icon>mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </div>
          <v-btn
            icon
            v-if="statusBroadcast === false && statusContact === false && chatView === false && statusSearch === false && JSON.stringify(to) !== '{}'"
            @click="statusSearch = true"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="
              fab = !fab;
              menu = false;
            "
          >
            <v-icon class="app-menu-indicator">mdi-window-minimize</v-icon>
          </v-btn>
        </v-toolbar>
        <v-row class="no-gutters elevation-4">
          <v-col cols="12" sm="4" class="flex-grow-1 flex-shrink-0" style="border-right: 1px solid #0000001f;">
            <!-- chat prev -->
            <v-responsive v-if="statusContact === false && statusBroadcast === false" class="overflow-y-auto fill-height" height="400" width="400">
              <v-text-field v-model="search" :label="$t('search')" class="ml-2 mr-2" @input="searchContact">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
              <v-list v-if="messageByUser.length" subheader>
                <v-list-item-group mandatory v-model="activeChat">
                  <template v-for="(item, index) in messageByUser">
                    <v-list-item :key="`parent${index}`" :value="item.userId" @click="changeAccount(item)">
                      <v-list-item-avatar color="grey lighten-1 white--text">
                        <v-img v-if="item.userPicture" :src="item.userPicture" />
                        <v-img v-else :src="require('@/assets/images/sample-user.png')" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <strong class="header-content"> {{ item.userName }} </strong>
                        <v-list-item-subtitle v-if="item.lastMessage">
                          <div class="d-flex justify-space-between">
                            <span class="text-content" v-if="item.lastMessage.content.length > 16">
                              {{ item.lastMessage.content.substring(0, 16) + '...' }}
                            </span>
                            <span class="text-content" v-else> {{ item.lastMessage.content }}</span>
                            <div class="unread" v-if="item.unRead > 0">
                              <span class="text-content white--text" style="font-size: 8px; justify-content: center;">
                                {{ item.unRead }}
                              </span>
                            </div>
                          </div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`chatDivider${index}`" class="my-0" />
                  </template>
                </v-list-item-group>
              </v-list>
              <template v-else>
                <strong class="d-flex justify-center welcome-chat-title" style="margin-top:160px;">
                  {{ $t('content.no_message_title') }}
                </strong>
                <p class="d-flex justify-center text-detail text-center">
                  {{ $t('content.no_message_body') }}
                </p>
              </template>
            </v-responsive>
            <!-- contact  -->
            <v-responsive v-if="statusContact === true && statusBroadcast === false" class="overflow-y-auto fill-height" height="400" width="400">
              <v-text-field v-model="search" :label="$t('search')" class="ml-2 mr-2" @input="searchContact">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
              <v-list subheader>
                <!-- student -->
                <strong class="ml-5" style="color:#6d6d6d;" v-if="contactArr.students ? contactArr.students.length > 0 : ''">
                  {{ $t('content.student') }}
                </strong>
                <v-list-item-group>
                  <template v-for="(item, index) in contactArr.students ? contactArr.students : ''">
                    <v-list-item :key="`parent${index}`" :value="item.userId" @click="changeAccount(item)">
                      <v-list-item-avatar color="grey lighten-1 white--text">
                        <v-img v-if="item.imageUrl" :src="item.imageUrl" />
                        <v-img v-else :src="require('@/assets/images/sample-user.png')" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <strong class="header-content"> {{ item.fullName }} </strong>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`chatDivider${index}`" class="my-0" />
                  </template>
                </v-list-item-group>
                <!-- teacher -->
                <strong class="ml-5" style="color:#6d6d6d;" v-if="contactArr.teachers ? contactArr.teachers.length > 0 : ''">
                  {{ $t('roles.teacher') }}
                </strong>
                <v-list-item-group>
                  <template v-for="(item, index) in contactArr.teachers ? contactArr.teachers : ''">
                    <v-list-item :key="`parent${index}`" :value="item.userId" @click="changeAccount(item)">
                      <v-list-item-avatar color="grey lighten-1 white--text">
                        <v-img v-if="item.imageUrl" :src="item.imageUrl" />
                        <v-img v-else :src="require('@/assets/images/sample-user.png')" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <strong class="header-content"> {{ item.fullName }} </strong>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`chatDivider${index}`" class="my-0" />
                  </template>
                </v-list-item-group>
                <!-- parents -->
                <strong class="ml-5" style="color:#6d6d6d;" v-if="contactArr.parents ? contactArr.parents.length > 0 : ''">
                  {{ $t('roles.parents') }}
                </strong>
                <v-list-item-group>
                  <template v-for="(item, index) in contactArr.parents ? contactArr.parents : ''">
                    <v-list-item :key="`parent${index}`" :value="item.userId" @click="changeAccount(item)">
                      <v-list-item-avatar color="grey lighten-1 white--text">
                        <v-img v-if="item.imageUrl" :src="item.imageUrl" />
                        <v-img v-else :src="require('@/assets/images/sample-user.png')" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <strong class="header-content"> {{ item.fullName }} </strong>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`chatDivider${index}`" class="my-0" />
                  </template>
                </v-list-item-group>
              </v-list>
            </v-responsive>
            <!-- BroadCast  -->
            <v-responsive v-if="statusBroadcast === true && statusContact === false" class="overflow-y-auto fill-height" height="400" width="400">
              <v-text-field v-model="search" :label="$t('search')" class="ml-2 mr-2" @input="searchContact">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
              <v-list subheader>
                <!-- student -->
                <v-list-item v-if="contactArr.students ? contactArr.students.length > 0 : ''">
                  <v-list-item-action>
                    <v-checkbox
                      :indeterminate="someNodesSelectedStudent"
                      :input-value="allNodesSelectedStudent"
                      @click.stop="toggleCompleteSelectionStudent"
                      color="secondary lighten-2 shrink mr-0 mt-0"
                      dense
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                    <strong style="color:#6d6d6d;" v-if="contactArr.students ? contactArr.students.length > 0 : ''">
                      {{ $t('content.student') }}
                    </strong>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item-group v-model="toArrStudent" multiple color="green">
                  <template v-for="(item, index) in contactArr.students ? contactArr.students : ''">
                    <v-list-item :key="`parent${index}`" :value="item">
                      <template v-slot:default="{ active }">
                        <v-list-item-avatar size="28" color="grey lighten-1 white--text">
                          <v-img v-if="item.imageUrl" :src="item.imageUrl" />
                          <v-img v-else :src="require('@/assets/images/sample-user.png')" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <strong class="header-content"> {{ item.fullName }} </strong>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-checkbox dense :input-value="active" color="secondary lighten-2 shrink mr-0 mt-0" />
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                    <v-divider :key="`chatDivider${index}`" class="my-0" />
                  </template>
                </v-list-item-group>

                <!-- teacher -->
                <v-list-item v-if="contactArr.teachers ? contactArr.teachers.length > 0 : ''">
                  <v-list-item-action>
                    <v-checkbox
                      :indeterminate="someNodesSelectedTeacher"
                      :input-value="allNodesSelectedTeacher"
                      @click.stop="toggleCompleteSelectionTeacher"
                      color="secondary lighten-2 shrink mr-0 mt-0"
                      dense
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                    <strong style="color:#6d6d6d;" v-if="contactArr.teachers ? contactArr.teachers.length > 0 : ''">
                      {{ $t('roles.teacher') }}
                    </strong>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item-group v-model="toArrTeacher" multiple color="green">
                  <template v-for="(item, index) in contactArr.teachers ? contactArr.teachers : ''">
                    <v-list-item :key="`parent${index}`" :value="item">
                      <template v-slot:default="{ active }">
                        <v-list-item-avatar size="28" color="grey lighten-1 white--text">
                          <v-img v-if="item.imageUrl" :src="item.imageUrl" />
                          <v-img v-else :src="require('@/assets/images/sample-user.png')" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <strong class="header-content"> {{ item.fullName }} </strong>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-checkbox dense :input-value="active" color="secondary lighten-2 shrink mr-0 mt-0" />
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                    <v-divider :key="`chatDivider${index}`" class="my-0" />
                  </template>
                </v-list-item-group>

                <!-- parents -->
                <v-list-item v-if="contactArr.parents ? contactArr.parents.length > 0 : ''">
                  <v-list-item-action>
                    <v-checkbox
                      :indeterminate="someNodesSelectedParent"
                      :input-value="allNodesSelectedParent"
                      @click.stop="toggleCompleteSelectionParent"
                      color="secondary lighten-2 shrink mr-0 mt-0"
                      dense
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                    <strong style="color:#6d6d6d;" v-if="contactArr.parents ? contactArr.parents.length > 0 : ''">
                      {{ $t('roles.parents') }}
                    </strong>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item-group v-model="toArrParent" multiple color="green">
                  <template v-for="(item, index) in contactArr.parents ? contactArr.parents : ''">
                    <v-list-item :key="`parent${index}`" :value="item">
                      <template v-slot:default="{ active }">
                        <v-list-item-avatar size="28" color="grey lighten-1 white--text">
                          <v-img v-if="item.imageUrl" :src="item.imageUrl" />
                          <v-img v-else :src="require('@/assets/images/sample-user.png')" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <strong class="header-content"> {{ item.fullName }} </strong>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-checkbox dense :input-value="active" color="secondary lighten-2 shrink mr-0 mt-0" />
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                    <v-divider :key="`chatDivider${index}`" class="my-0" />
                  </template>
                </v-list-item-group>
              </v-list>
              <!-- test -->
            </v-responsive>
          </v-col>
          <!-- chat  -->
          <v-col cols="auto" class="flex-grow-1 flex-shrink-0" style="width: 200px;">
            <v-responsive class="overflow-y-hidden fill-height">
              <!-- chat dalem -->
              <v-card flat class="d-flex flex-column fill-height" height="400" v-if="chatView === false">
                <!-- body  -->
                <template v-if="JSON.stringify(to) !== '{}' || toArrStudent.length > 0 || toArrTeacher.length > 0 || toArrParent.length > 0">
                  <v-card-text ref="toolbarChat" class="flex-grow-1" style="max-height:100%;overflow-y: auto; width:300;">
                    <div class="d-flex justify-center mb-2">
                      <v-btn
                        depressed
                        small
                        @click="loadMore"
                        :loading="loadingMore"
                        v-if="
                          statusBroadcast === false &&
                            statusContact === false &&
                            JSON.stringify(to) !== '{}' &&
                            messageList.length >= 10 &&
                            loadMoreStat === false
                        "
                      >
                        {{ $t('content.load_more') }}
                      </v-btn>
                    </div>
                    <div
                      v-if="
                        statusBroadcast === false && statusContact === false && messageList && Array.isArray(messageList) && messageList.length > 0
                      "
                    >
                      <div v-for="(msg, i) in messageList" :key="i">
                        <div :class="msg.isFromSelf ? 'd-flex flex-row-reverse' : 'd-flex'">
                          <template>
                            <v-card
                              :color="msg.isFromSelf ? 'secondary' : 'primary'"
                              dark
                              :style="msg.content && msg.content.length >= 49 ? 'width:70%' : ''"
                              class="pa-1 mb-2 text-chat"
                              small
                              :id="msg.id"
                            >
                              <div class="ml-2 mr-2">
                                <v-hover v-slot="{ hover }">
                                  <div class="d-flex justify-space-between" :class="{ 'on-hover': hover }">
                                    <span v-if="msg.type === 'TEXT'">
                                      <text-highlight :queries="searchChat">{{ msg.content }}</text-highlight>
                                    </span>

                                    <!-- File Viewer -->
                                    <a
                                      class="yellow--text darken-4 text-decoration-underline"
                                      v-if="msg.type === 'FILE'"
                                      href="javascript:(0)"
                                      @click.prevent="previewFileTeacher(undefined, { fileList: msg.meta })"
                                      >{{ msg.content }}</a
                                    >
                                    <v-menu top :close-on-click="closeOnClick" rounded="lg">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon small :class="{ 'show-btns': hover }" v-bind="attrs" v-on="on">
                                          <v-icon :class="{ 'show-btns': hover }" :color="transparent">mdi-chevron-down</v-icon>
                                        </v-btn>
                                      </template>
                                      <v-list>
                                        <v-list-item link @click="goDelete(msg)">
                                          <v-list-item-title style="color: red;">{{ $t('content.delete') }}</v-list-item-title>
                                        </v-list-item>
                                      </v-list>
                                    </v-menu>
                                  </div>
                                </v-hover>
                                <sub class="mt-4 d-flex flex-row-reverse mb-2" style="font-size: 0.5rem;">{{ formatDate(msg.createdAt) }}</sub>
                              </div>
                            </v-card>
                          </template>
                        </div>
                      </div>
                    </div>
                  </v-card-text>

                  <!-- content text and file  -->
                  <v-card-text
                    class="flex-shrink-1"
                    v-if="
                      (statusContact === false && JSON.stringify(to) !== '{}') ||
                        toArrStudent.length > 0 ||
                        toArrTeacher.length > 0 ||
                        toArrParent.length > 0
                    "
                  >
                    <!-- content text   -->
                    <v-text-field
                      v-if="fileType === false"
                      v-model="messageContent.content"
                      label="Type a message"
                      type="text"
                      no-details
                      outlined
                      dense
                      prepend-icon="mdi-paperclip"
                      append-outer-icon="mdi-send"
                      @keyup.enter="incomingMessage"
                      @click:append-outer="incomingMessage"
                      @click:prepend="onClickRefsFile()"
                      hide-details
                    />

                    <!-- content  file  -->
                    <form-group v-if="fileType === true && messageFile" :name="$t('form.file')" :validator="$v.messageFile" no-gutter>
                      <template slot-scope="{ attrs }">
                        <v-file-input
                          v-bind="attrs"
                          v-if="fileType === true && messageFile"
                          v-model="messageFile"
                          label="File Name"
                          outlined
                          dense
                          clearable
                          show-size
                          append-outer-icon="mdi-send"
                          accept=".jpg,.jpeg,.png,.pdf,.mp4,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.mp3"
                          @click:append-outer="incomingFile"
                          @click:clear="onClearClicked()"
                          :loading="loadingUpload"
                          :disabled="loadingUpload === true"
                          @input="$v.messageFile.$touch()"
                          @blur="$v.messageFile.$touch()"
                        >
                          <template v-slot:selection="{ text }">
                            <v-chip small label color="primary">
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </template>
                    </form-group>

                    <input
                      type="file"
                      accept=".jpg,.jpeg,.png,.pdf,.mp4,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.mp3"
                      v-if="!messageFile"
                      style="display: none"
                      ref="files"
                      @change="onFilePicked"
                      @input="$v.messageFile.$touch()"
                      @blur="$v.messageFile.$touch()"
                    />
                  </v-card-text>
                </template>
                <!-- not found chat -->
                <template v-else>
                  <p class="d-flex justify-center" style="margin-top:100px;">
                    <svg-icon icon="message" width="200" height="100" />
                  </p>
                  <strong class="d-flex justify-center welcome-chat-title">
                    {{ $t('content.welcome_chat_title') }}
                  </strong>
                  <p class="d-flex justify-center text-detail">
                    {{ $t('content.welcome_chat_body') }}
                  </p>
                </template>
              </v-card>

              <!-- detail contact -->
              <v-card flat class="d-flex flex-column fill-height pa-3 overflow-y-hidden" height="400" v-else>
                <v-card-text style="overflow-y: auto;">
                  <div class="d-flex justify-center">
                    <v-list-item-avatar size="80" color="grey lighten-1 white--text mt-2 ml-4">
                      <v-img v-if="detailContact.imageUrl" :src="detailContact.imageUrl" />
                      <v-img v-else :src="require('@/assets/images/sample-user.png')" />
                    </v-list-item-avatar>
                  </div>
                  <div class="d-flex justify-center mt-2">
                    <strong class="text-detail" style="justify-content: center;">{{ detailContact.fullName }}</strong>
                  </div>
                  <div class="d-flex justify-center mt-2">
                    <span class="text-detail" style="justify-content: center;">{{ detailContact.email }}</span>
                  </div>
                  <div class="d-flex justify-center mt-2">
                    <span class="text-detail" style="justify-content: center;">{{ detailContact.schoolName }}</span>
                  </div>
                  <div class="d-flex justify-center mt-2">
                    <div class="d-flex justify-center detailTeacher">
                      <span v-if="detailContact.roleId === 4" class="white--text" style="justify-content: center;">{{ $t('roles.teacher') }}</span>
                      <span v-if="detailContact.roleId === 5" class="white--text" style="justify-content: center;">{{ $t('roles.student') }}</span>
                      <span v-if="detailContact.roleId === 3" class="white--text" style="justify-content: center;">{{ $t('roles.parents') }}</span>
                    </div>
                  </div>
                  <v-divider class="mt-4" />
                  <strong class="text-detail mt-3">{{ $t('content.classroom') }} {{ $t('menu.course') }}</strong>
                  <div v-for="(dataClass, index) in detailContact.classroomCourse" :key="index" class="classroom-course-detail pa-1 mt-2">
                    <span class="text-detail">{{ dataClass }}</span>
                  </div>
                </v-card-text>
              </v-card>
              <!-- Dialog Delete -->
              <v-dialog v-model="dialogDeleteChat" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
                  <v-card-text>{{ $t('delete_message') }}</v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogDeleteChat = false">{{ $t('disagree') }}</v-btn>
                    <v-btn text @click="deleteDetail">{{ $t('aggree') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-responsive>
          </v-col>
        </v-row>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SlideBox from '@/components/SlideBox';
import sidebar from '@/components/sidebar/SidebarItems';
import socketChat from '@/plugins/socketChat';
import { fileSize, fileType } from '@/validators';
import FileViewer from '@/components/FileViewer';
import TextHighlight from 'vue-text-highlight';
import moment from 'moment-timezone';

const extAllowed = ['mp4', 'mp3', 'pptx', 'ppt', 'doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'png', 'jpeg'];

export default {
  name: 'BaseSidebar',
  components: {
    SlideBox,
    FileViewer,
    TextHighlight
  },
  props: {
    // sidebarItems: {
    //   type: Array,
    //   required: true
    // }
  },
  computed: {
    ...mapGetters({
      role: 'Auth/currentRole',
      user: 'Auth/user',
      student: 'Auth/student',
      childs: 'ChildList/items',
      permission: 'Auth/permission'
    }),
    menus() {
      return sidebar[this.role] ? sidebar[this.role].filter(item => this.permission?.includes(item?.id)) : [];
    },
    profile() {
      return {
        imageUrl: this.user.imageUrl,
        fullName: `${this.user.firstName ?? ''} ${this.user.lastName ?? ''}`,
        roleId: this.user.roleId
        // imageUrl: this.role === 3 && !!this.student ? this.student?.imageUrl : this.user?.imageUrl,
        // fullName: this.role === 3 && !!this.student ? this.student?.fullName : this.user?.fullName,
        // roleId: this.role === 3 && !!this.student ? 5 : this.user.roleId
      };
    },
    currentRole() {
      const locales = {
        1: 'roles.master_administrator',
        2: 'roles.school_administrator',
        3: 'roles.parents',
        4: 'roles.teacher',
        5: 'roles.student',
        6: 'roles.school_advisor'
      };
      const findRole = locales?.[this.profile.roleId];
      return findRole ? this.$t(findRole) : '-';
    },
    URL() {
      return process.env.VUE_APP_BASE_URL;
    },
    noNodesSelectedStudent() {
      return this.toArrStudent.length === 0;
    },
    someNodesSelectedStudent() {
      return this.toArrStudent.length > 0 && !this.allNodesSelectedStudent;
    },
    allNodesSelectedStudent() {
      return this.toArrStudent.length === this.contactArr.students.length;
    },
    noNodesSelectedTeacher() {
      return this.toArrTeacher.length === 0;
    },
    someNodesSelectedTeacher() {
      return this.toArrTeacher.length > 0 && !this.allNodesSelectedTeacher;
    },
    allNodesSelectedTeacher() {
      return this.toArrTeacher.length === this.contactArr.teachers.length;
    },
    noNodesSelectedParent() {
      return this.toArrParent.length === 0;
    },
    someNodesSelectedParent() {
      return this.toArrParent.length > 0 && !this.allNodesSelectedParent;
    },
    allNodesSelectedParent() {
      return this.toArrParent.length === this.contactArr.parents.length;
    }
  },
  validations() {
    return {
      messageFile: {
        fileSize: fileSize(2000),
        fileType: fileType(extAllowed)
      }
    };
  },
  watch: {
    menu: {
      handler: function(open) {
        if (open) socketChat.emit('FETCH_USER_CONVERSATION');
      }
    },
    student: {
      immediate: true,
      handler: function(newVal) {
        this.currentActiveStudent = newVal?.studentId ?? null;
        if (!newVal) return;

        this.initChat();
      }
    }
  },
  data: () => ({
    sidebar: false,
    currentActiveStudent: null,
    fab: false,
    menu: false,
    dialog: false,
    messageContent: { type: 'TEXT', content: '' },
    messageByUser: [],
    messageList: [],
    messageFile: null,
    fileName: '',
    to: {},
    contactArr: [],
    search: '',
    searchChat: '',
    statusContact: false,
    statusBroadcast: false,
    toArr: [],
    toArrStudent: [],
    toArrTeacher: [],
    toArrParent: [],
    activeChat: '',
    fileType: false,
    hover: false,
    loadingUpload: false,
    page: 1,
    chatView: false,
    statusSearch: false,
    loadingMore: false,
    detailContact: '',
    dialogPreview: false,
    preview: {},
    OnIndexSearch: 0,
    setListSearch: [],
    searchChatId: '',
    loadMoreStat: false,
    chatId: '',
    transparent: 'rgba(255, 255, 255, 0)',
    closeOnClick: true,
    dialogDeleteChat: false,
    currentItemDelete: '',
    unread: 0
  }),
  methods: {
    // File Viewer Teacher
    previewFileTeacher(e, { fileList }) {
      this.dialogPreview = true;
      fileList.key = fileList.URL;
      fileList.fileName = fileList.name;
      fileList.fileUrl = `${process.env.VUE_APP_BASE_URL_FILE}${fileList.URL}`;
      fileList.size = '186 KB';
      this.menu = false;
      this.$set(this, 'preview', fileList);
    },
    hidePreview() {
      this.dialogPreview = null;
      this.$set(this, 'preview', {});
    },
    toggleCompleteSelectionStudent() {
      if (this.noNodesSelectedStudent || this.someNodesSelectedStudent) {
        this.toArrStudent = this.contactArr.students.map(node => node);
      } else {
        this.toArrStudent = [];
      }
    },
    toggleCompleteSelectionTeacher() {
      if (this.noNodesSelectedTeacher || this.someNodesSelectedTeacher) {
        this.toArrTeacher = this.contactArr.teachers.map(node => node);
      } else {
        this.toArrTeacher = [];
      }
    },
    toggleCompleteSelectionParent() {
      if (this.noNodesSelectedParent || this.someNodesSelectedParent) {
        this.toArrParent = this.contactArr.parents.map(node => node);
      } else {
        this.toArrParent = [];
      }
    },
    getChild() {
      this.loading = true;
      this.$store.dispatch('ChildList/fetchList').finally(() => (this.loading = false));
    },
    getProfile() {
      this.$store.dispatch('User/fetchProfile').then(res => {
        // Every Refresh Update Separate Data
        const { firstName, lastName, roleId, imageUrl, gmt, language } = res;
        this.$store.commit('Auth/SET_USER', { firstName, lastName, roleId, imageUrl, gmt, language });
      });
    },
    detailProfile() {
      this.$router.push({ name: 'Profile' }).catch(() => {});
    },
    changeStudent(value) {
      const student = this.childs.find(child => child?.studentId === value);
      if (student) {
        this.$store.commit('Auth/SET_STUDENT', student);
        this.$router.push({ name: 'ParentClassIndex' });
      }
    },
    incomingMessage() {
      if (this.messageContent.content && this.statusContact === false && this.statusBroadcast === false) {
        let content = this.messageContent;
        let to = this.to;
        socketChat.emit('SEND_PRIVATE_MESSAGE', content, [to]);
        this.messageContent.content = null;
        this.scrollToEnd();
        this.activeChat = null;
        socketChat.emit('READ_MESSAGE', { ...this.to, id_chat: this.to.id_chat });
        setTimeout(() => {
          this.activeChat = to.id;
        }, 200);
      } else {
        let datas = this.toArrStudent.concat(this.toArrTeacher);
        this.toArr = datas.concat(this.toArrParent);
        if (this.toArr.length) {
          this.toArr.forEach(datas => {
            datas.id_chat = datas.chatId ? datas.chatId : null;
            datas.id = datas.userId;
            datas.name = datas.fullName;
            datas.profileImg = datas.imageUrl;
          });
          socketChat.emit('SEND_PRIVATE_MESSAGE', this.messageContent, this.toArr);
          socketChat.emit('READ_MESSAGE', { ...this.to, id_chat: this.to.id_chat });
          this.messageContent.content = null;
          this.statusBroadcast = false;
          this.scrollToEnd();
          setTimeout(() => {
            this.to = this.toArr[0];
            this.activeChat = this.toArr[0].id;
            this.toArrStudent = [];
            this.toArrTeacher = [];
            this.toArrParent = [];
            this.toArr = [];
          }, 100);
        }
      }
    },
    // Util
    cleanFileName(str) {
      return str
        .match(/[\w\d\s\\,\\_\\(\\)-]*/gm)
        .reduce((acc, row) => {
          acc += row;
          return acc;
        }, '')
        .trim();
    },
    incomingFile() {
      this.$v.messageFile.$touch();
      if (this.$v.messageFile.$invalid) return false;

      const formData = new FormData();
      formData.append('file', this.messageFile);
      this.loadingUpload = true;
      this.axios
        .post(this.user.roleId === 3 ? `${this.URL}api/chat/upload?studentId=${this.student?.studentId}` : `${this.URL}api/chat/upload`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(response => {
          let filename = this.fileName.split('.').shift();
          filename = this.cleanFileName(filename);
          let upload = {
            type: 'FILE',
            content: `${filename ? filename : 'file'}.${response.data.data.meta.extension}`,
            meta: {
              URL: response.data.data.url,
              extension: response.data.data.meta.extension,
              name: `${filename ? filename : 'file'}.${response.data.data.meta.extension}`
            }
          };

          if (this.statusContact === false && this.statusBroadcast === false) {
            socketChat.emit('SEND_PRIVATE_MESSAGE', upload, [this.to]);
          } else {
            let datas = this.toArrStudent.concat(this.toArrTeacher);
            this.toArr = datas.concat(this.toArrParent);
            if (this.toArr.length) {
              this.toArr.forEach(datas => {
                datas.id_chat = datas.chatId ? datas.chatId : null;
                datas.id = datas.userId;
                datas.name = datas.fullName;
                datas.profileImg = datas.imageUrl;
              });
              socketChat.emit('SEND_PRIVATE_MESSAGE', upload, this.toArr);
              setTimeout(() => {
                this.to = this.toArr[0];
                this.activeChat = this.toArr[0].id;
                this.toArrStudent = [];
                this.toArrTeacher = [];
                this.toArrParent = [];
                this.toArr = [];
              }, 100);
            }
          }
          this.scrollToEnd();
        })
        .finally(() => {
          this.loadingUpload = false;
          this.fileType = false;
          this.fileName = '';
          this.messageFile = null;
          this.statusBroadcast = false;
        });
    },
    changeAccount(item) {
      if (this.chatView === false) {
        this.statusSearch = false;
        this.searchChat = '';
        let page = this.page;

        let obj = this.messageByUser.find(o => o.userId === item.userId);
        this.activeChat = item.userId;
        this.to = {
          id: item.userId,
          id_chat: item.lastMessage ? item.lastMessage.chatId : null,
          name: item.userName ? item.userName : item.fullName,
          profileImg: item.userPicture ? item.userPicture : item.imageUrl
        };

        if (!obj) {
          this.messageByUser.push({
            userId: item.userId,
            userName: item.userName ? item.userName : item.fullName,
            userPicture: item.userPicture ? item.userPicture : item.imageUrl,
            id_chat: item.chatId
          });
        }

        socketChat.emit('FETCH_MESSAGE', this.to, page);
        if (this.to.id_chat && item.unRead > 0) {
          socketChat.emit('READ_MESSAGE', this.to);
        }

        this.statusContact = false;

        this.scrollToEnd();
        this.fileType = false;
        this.fileName = '';
        this.messageFile = null;
      } else {
        this.chatView = false;
      }
    },
    scrollToEnd: function() {
      let container = this.$refs.toolbarChat;
      container.scrollTop = container.scrollHeight;
    },
    listContact() {
      if (this.user.roleId === 5) {
        this.axios.get(`${this.URL}api/user/student/contacts`).then(response => {
          this.contactArr = response.data.data;
        });
      } else if (this.user.roleId === 3 && this.student?.studentId) {
        this.axios.get(`${this.URL}api/user/parent/student/${this.student?.studentId ? this.student?.studentId : ''}/contact`).then(response => {
          this.contactArr = response.data.data;
        });
      } else if (this.user.roleId === 4) {
        this.axios.get(`${this.URL}api/user/teacher/contacts`).then(response => {
          this.contactArr = response.data.data;
        });
      }
    },
    searchContact() {
      let search = this.search;
      if (this.statusContact === false && this.statusBroadcast === false) {
        socketChat.emit('FETCH_USER_CONVERSATION', search);
      } else if ((this.statusContact === true) | (this.statusBroadcast === true)) {
        if (this.user.roleId === 5) {
          this.axios.get(`${this.URL}api/user/student/contacts?search=${search}`).then(response => {
            this.contactArr = response.data.data;
          });
        } else if (this.user.roleId === 4) {
          this.axios.get(`${this.URL}api/user/teacher/contacts?search=${search}`).then(response => {
            this.contactArr = response.data.data;
          });
        }
      }
    },
    loadMore() {
      this.loadingMore = true;
      setTimeout(() => {
        let page = 1 + this.page++;
        let to = this.to;
        // socketChat.emit('FETCH_PREV_SEARCH_MESSAGE', to, page);
        // socketChat.on('PREV_SEARCH_MESSAGE_SENT', messageList => {
        //   this.messageList = messageList;
        socketChat.emit('FETCH_MESSAGE', to, page, this.searchChat);
        socketChat.on('MESSAGE_SENT', (messageList, ArraySearch, isIncludeFirstChat) => {
          this.loadMoreStat = isIncludeFirstChat;
          this.loadMoreStat = this.loadMoreStat.isIncludeFirstChat;
          this.setListSearch = ArraySearch;
          this.messageList = messageList;
        });
        // });

        this.loadingMore = false;
      }, 350);
    },
    searchChatInput() {
      let search = this.searchChat;
      let to = this.to;
      let page = this.page;
      socketChat.emit('FETCH_MESSAGE', to, page, search);
      this.OnIndexSearch = 0;
      this.setListSearch = [];
    },
    goTopSearch() {
      if (this.chatId === this.setListSearch[this.OnIndexSearch]?.id) {
        this.OnIndexSearch = this.OnIndexSearch + 1;
      }
      if (this.setListSearch[this.OnIndexSearch]) {
        let search = this.searchChat;
        let to = this.to;
        let page;
        if (this.setListSearch[this.OnIndexSearch]?.page >= this.page) {
          page = this.setListSearch[this.OnIndexSearch]?.page;
        } else {
          page = this.page;
        }
        socketChat.emit('FETCH_PREV_SEARCH_MESSAGE', to, page, search);
        location.href = `#${this.setListSearch[this.OnIndexSearch]?.id}`;
        this.chatId = this.setListSearch[this.OnIndexSearch]?.id;
        let indexSearch = this.OnIndexSearch;
        this.OnIndexSearch = indexSearch + 1;
        socketChat.on('PREV_SEARCH_MESSAGE_SENT', (messageList, LasPage) => {
          this.page = LasPage;
          this.messageList = messageList;
        });
      } else {
        location.href = `#`;
        this.$store.dispatch('general/showErrorNotification', { message: 'Search not found' });
      }
    },
    goDownSearch() {
      if (this.setListSearch[this.OnIndexSearch]) {
        let search = this.searchChat;
        let to = this.to;
        let page;
        if (this.setListSearch[this.OnIndexSearch]?.page >= this.page) {
          page = this.setListSearch[this.OnIndexSearch]?.page;
        } else {
          page = this.page;
        }
        socketChat.emit('FETCH_PREV_SEARCH_MESSAGE', to, page, search);
        location.href = `#${this.setListSearch[this.OnIndexSearch]?.id}`;
        this.chatId = this.setListSearch[this.OnIndexSearch]?.id;
        let indexSearch = this.OnIndexSearch;
        if (indexSearch - 1 === -1) {
          this.OnIndexSearch = 0;
        } else {
          this.OnIndexSearch = indexSearch - 1;
        }
        socketChat.on('PREV_SEARCH_MESSAGE_SENT', (messageList, LasPage) => {
          this.page = LasPage;
          this.messageList = messageList;
        });
      } else {
        location.href = `#`;
        this.$store.dispatch('general/showErrorNotification', { message: 'Search not found' });
      }
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.fileType = true;
        this.fileName = files[0].name;
        this.messageFile = files[0];
      } else {
        this.fileType = false;
        this.fileName = '';
        this.messageFile = null;
      }
    },
    onClearClicked: function() {
      this.fileType = false;
      this.fileName = '';
      this.messageFile = null;
    },
    onClickRefsFile() {
      this.$refs.files.click();
    },
    detailProfileChat() {
      this.axios
        .get(`${this.URL}api/user/${this.to.id}/detail-contact`)
        .then(response => {
          this.detailContact = response.data.data;
        })
        .finally(() => (this.chatView = true));
    },
    goDelete(item) {
      this.dialogDeleteChat = true;
      this.currentItemDelete = item.id;
    },
    deleteDetail() {
      if (!this.currentItemDelete) return false;
      let messageId = this.currentItemDelete;
      let to = this.to;
      let Page = this.page;
      let Search = this.searchChat;
      socketChat.emit('DELETE_MESSAGE', messageId, to, Page, Search);
      socketChat.on('MESSAGE_SENT', (messageList, ArraySearch, isIncludeFirstChat) => {
        this.loadMoreStat = isIncludeFirstChat;
        this.loadMoreStat = this.loadMoreStat.isIncludeFirstChat;
        this.setListSearch = ArraySearch;
        this.messageList = messageList;
      });
      this.dialogDeleteChat = false;
      this.currentItemDelete = '';
    },
    formatDate(date, timezone = 'Asia/Jakarta') {
      try {
        const momentObj = moment(date);
        if (moment.tz.zone(timezone)) {
          return momentObj.tz(timezone).format('YYYY-MM-DD HH:mm');
        } else {
          return momentObj.format('YYYY-MM-DD HH:mm');
        }
      } catch (error) {
        return moment().format('YYYY-MM-DD HH:mm');
      }
    },

    // Initial Function
    initProfile() {
      this.getProfile();

      if (this.role === 3 && this.student) {
        this.getChild();
      }
    },

    initSidebarEvents() {
      this.$root.$on('showHideMenu', () => {
        this.sidebar = !this.sidebar;
      });

      document.addEventListener('click', e => {
        const triggerBtn = document.getElementById('app-header-trigger-btn');
        if (!triggerBtn?.contains(e.target)) {
          this.sidebar = false;
        }
      });
    },

    initChat() {
      this.listContact();

      const token = 'ask_your_tech_lead';
      socketChat.auth = {
        token,
        userId: this.user.userId,
        username: this.user.fullName,
        profileImage: this.user.imageUrl
      };
      socketChat.connect();

      socketChat.once('connect', () => {
        this.setupChatListeners();
      });
    },

    setupChatListeners() {
      socketChat.off('USER_CONVERSATION_SENT'); // prevent duplicate
      socketChat.on('USER_CONVERSATION_SENT', this.handleUserConversation);

      socketChat.off('PRIVATE_MESSAGE_SENT');
      socketChat.on('PRIVATE_MESSAGE_SENT', this.handlePrivateMessage);

      socketChat.off('connect_error');
      socketChat.on('connect_error', this.handleConnectError);
    },

    handleUserConversation(messageByUser) {
      this.unread = messageByUser.reduce((n, { unRead }) => n + unRead, 0);

      if (!Object.keys(this.to).length && messageByUser[0]) {
        const firstMsg = messageByUser[0];
        this.to = {
          id: firstMsg.userId,
          id_chat: firstMsg.lastMessage.chatId,
          name: firstMsg.userName || firstMsg.fullName,
          profileImg: firstMsg.userPicture
        };
      }

      this.messageByUser = messageByUser;

      socketChat.emit('FETCH_MESSAGE', this.to, this.page, this.searchChat);

      socketChat.off('MESSAGE_SENT');
      socketChat.on('MESSAGE_SENT', this.handleMessageSent);

      this.activeChat = null;
      setTimeout(() => {
        this.activeChat = this.to.id;
      }, 200);
    },

    handleMessageSent(messageList, ArraySearch, isIncludeFirstChat) {
      this.loadMoreStat = isIncludeFirstChat?.isIncludeFirstChat ?? isIncludeFirstChat;
      this.setListSearch = ArraySearch;
      this.messageList = messageList;
    },

    handlePrivateMessage(message) {
      this.messageList.push({
        ...message,
        isFromSelf: message.sender === this.user.userId
      });
    },

    handleConnectError(err) {
      console.error('Socket connect error:', err);
    }
  },

  mounted() {
    this.initProfile();
    this.initSidebarEvents();

    if ([3, 4, 5].includes(this.user.roleId)) {
      this.initChat();
    }
  },

  beforeDestroy() {
    socketChat.off('USER_CONVERSATION_SENT');
    socketChat.off('MESSAGE_SENT');
    socketChat.off('PRIVATE_MESSAGE_SENT');
    socketChat.off('connect_error');
  }
};
</script>

<style lang="scss">
.app-sidebar {
  width: 280px;
  background: #fff;
  position: fixed;
  top: 0;
  left: -300px;
  bottom: 0;
  box-shadow: 10px 5px 18px 0 rgba(0, 0, 0, 0.09);
  box-sizing: border-box;
  padding: 16px;
  font-family: Montserrat;
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  z-index: 120;

  &.open {
    left: 0;
  }

  &-logo {
    height: 36px;
  }

  &-user {
    padding: 15px 0;
    margin: 15px 0;
    border-top: 2px dashed #999;
    border-bottom: 2px dashed #999;
    display: flex;
    align-items: flex-start;
    column-gap: 0.5rem;
    cursor: pointer;
    transition: all 300ms cubic-bezier(0.645, 0.045, 0.355, 1);

    &:hover {
      padding: 15px 10px;
    }

    .user {
      &-photo {
        width: 58px;
        aspect-ratio: 1/1;
        overflow: hidden;
        border-radius: 100%;
        margin-right: 10px;
        object-fit: cover;
      }

      &-info {
        width: 220px;
        &-primary {
          font-weight: 800;
          font-size: 14px;
          word-break: break-all;
          color: #6d6d6d;
        }

        &-secondary {
          font-weight: 500;
          font-size: 12px;
          color: #acacac;
        }
      }

      &-indicator {
        background: #ce8800;
        width: 24px;
        height: 24px;
        justify-self: flex-end;
        border-radius: 4px;
        color: #fff;
      }
    }
  }

  &.lite {
    background: red;
  }
}

.app-menu {
  list-style: none;
  margin: 0;
  padding: 0 !important;

  li {
    margin-bottom: 2px;

    a {
      text-decoration: none;
      font-weight: 800;
      display: block;
      padding: 8px;
      color: #6d6d6d;
      font-size: 12px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      transition: background 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94), color 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);

      &:hover {
        background: lighten(#ce8800, 10);
        color: #fff;
      }

      &.router-link-active {
        background: #ce8800;
        box-shadow: 0 7px 15px 0 rgba(237, 174, 73, 0.32);
        color: #fff;
      }
    }
  }

  &-icon {
    @extend %icon-wrapper;
    flex: none;
    background-color: #fff0d8;

    svg {
      fill: #edae49;
    }
  }

  &-text {
    flex: 1;
  }

  &-group {
    .slidebox-activator {
      display: flex;
      align-items: center;
      padding: 10px;
      font-family: Montserrat;
      font-weight: 800;
      font-size: 12px;
      color: #6d6d6d;
    }

    &-items {
      margin-top: 10px;
      transition: all 300ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
      list-style: none;
      padding: 0 !important;

      li {
        a {
          position: relative;

          &:before {
            content: '';
            border: 2px solid #eeae4a;
            width: 10px;
            height: 10px;
            border-radius: 4px;
            margin-left: 10px;
            margin-right: 18px;
          }

          &:hover {
            background: #fff0d8 !important;
            color: #6d6d6d !important;
            box-shadow: none;
          }

          &.router-link-active {
            box-shadow: none;
          }
        }
      }
    }
  }
}

.app-icon {
  width: 24px;
  height: 24px;
}

.student-list {
  display: flex;
  align-items: center;

  &-photo {
    width: 25px;
    height: 25px;
    margin-right: 10px;
    border-radius: 50%;
  }
}

.student-option {
  position: absolute;
  bottom: 0;
  left: 0;
  margin-bottom: 40px;
  padding: 10px 20px;
}

@include query-min-md() {
  .app-sidebar {
    top: 12px;
    left: 12px;
    bottom: 12px;
    border-radius: 8px;
  }
}

.lite-card {
  background-color: #017ced;
  border-radius: 1px 85px 1px 100px;
  opacity: 0.6356967659883721;
  width: 51px;
  height: 21px;
}

.lite-text {
  color: #ffffff;
  font-family: Montserrat;
  font-size: 10px;
  line-height: 12px;
  text-align: left;
  margin-top: 4px;
}
.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
}
.text-content {
  color: #000000;
  font-family: Montserrat;
  font-size: 10px;
  line-height: 12px;
  text-align: left;
}
.text-chat {
  border-radius: 0 8px 8px;
  white-space: normal;
}
.unread {
  background-color: #ffae00;
  border-radius: 3px;
  width: 12px;
  height: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.detailTeacher {
  background-color: #2989ca;
  border-radius: 16px;
  width: 93px;
  height: 24px;
}
.text-detail {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 24px;
}
.classroom-course-detail {
  background-color: #dcedf9;
  border-radius: 4px;
}

.welcome-chat-title {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 17px;
}

.highlight {
  font-weight: bold;
  color: yellow;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>
